import React, { useState } from 'react';
import styles from './index.module.scss';
import { showError, showSuccess } from 'utils';
import { addSalesChannelsToInventoryItem } from 'services/api/salesChannel';
import SalesChannelsMultiSelect from 'components/SalesChannelsMultiSelect';

const AddItemToSalesChannelModel = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const { itemId, onSuccess, toggleModal } = props;
  const [selectedSalesChannels, setSelectedSalesChannels] = useState([]);

  const addSalesChannelFn = async () => {
    setLoading(true);
    try {
      const selectedSalesChannelIds = selectedSalesChannels?.map((channel: any)=>channel?.value);
      await addSalesChannelsToInventoryItem({
        salesChannelIds: selectedSalesChannelIds,
        inventoryItemId: itemId,
      });
      await onSuccess(selectedSalesChannels);
      showSuccess('Item added to added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Inventory Item</div>
            <div className={styles['modal-title']}>Add Sales Channel</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Channels</div>
            <SalesChannelsMultiSelect 
              value={selectedSalesChannels} 
              onChange={setSelectedSalesChannels}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={addSalesChannelFn}
            className={styles['submit-button']}
            disabled={loading || !selectedSalesChannels?.length}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddItemToSalesChannelModel;
